import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { Sc4FailedMessagesListInitialState, Sc4FailedMessagesListLoad } from './sc4-failed-messages-list.actions';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Sc4FailedMessagesListService } from './sc4-failed-messages-list.service';
import {
  Error,
  CustomHttpErrorResponse,
  NotificationService,
  LIST_SERVER_PAGINATION_INITIAL_STATE,
  ListServerPaginationStateModel,
} from '../../../../../../common';
import { Sc4FailedMessagesModel } from '../../models';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type Sc4FailedMessagesListStateModel = ListServerPaginationStateModel<Sc4FailedMessagesModel>;

const initialState: Sc4FailedMessagesListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<Sc4FailedMessagesListStateModel>({
  name: 'sc4FailedMessagesList',
  defaults: initialState,
})
@Injectable()
export class Sc4FailedMessagesListState {
  constructor(
    private sc4FailedMessagesListService: Sc4FailedMessagesListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: Sc4FailedMessagesListStateModel): Sc4FailedMessagesListStateModel {
    return state;
  }
  @Selector()
  static getItems(state: Sc4FailedMessagesListStateModel): Sc4FailedMessagesModel[] {
    return state.items;
  }
  @Selector()
  static getTotalElements(state: Sc4FailedMessagesListStateModel): number {
    return state.totalElements;
  }
  @Selector()
  static getLoaded(state: Sc4FailedMessagesListStateModel): boolean {
    return state.loaded;
  }

  @Action(Sc4FailedMessagesListLoad)
  getPartners(
    ctx: StateContext<Sc4FailedMessagesListStateModel>,
    { payload }: Sc4FailedMessagesListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.sc4FailedMessagesListService.getSc4FailedMessagesList(payload).pipe(
      take(1),
      map((items: Sc4FailedMessagesModel[]) => {
        ctx.patchState({ ...items, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(Sc4FailedMessagesListInitialState)
  setInitialState(ctx: StateContext<Sc4FailedMessagesListStateModel>): void {
    ctx.setState(initialState);
  }
}
